type SignalWithAssetId = {
  assetId?: string | null;
};

type AssetSignalCount = {
  assetId: string | null;
  signalCount: number;
};

export const UNRESOLVED_AI_SIGNAL_ASSET_COUNT_KEY =
  '__unresolved_ai_signal_asset__';

export function aggregateSignalCountsByAssetId(
  signals: SignalWithAssetId[],
): Record<string, number> {
  const counts: Record<string, number> = {};

  for (const signal of signals) {
    const assetKey = signal.assetId ?? UNRESOLVED_AI_SIGNAL_ASSET_COUNT_KEY;
    counts[assetKey] = (counts[assetKey] ?? 0) + 1;
  }

  return counts;
}

export function toSignalCountsByAssetIdRecord(
  assetCounts: AssetSignalCount[],
): Record<string, number> {
  return assetCounts.reduce<Record<string, number>>((counts, assetCount) => {
    const assetKey = assetCount.assetId ?? UNRESOLVED_AI_SIGNAL_ASSET_COUNT_KEY;
    counts[assetKey] = (counts[assetKey] ?? 0) + assetCount.signalCount;
    return counts;
  }, {});
}
